module.exports = __webpack_public_path__ + "static/media/gramophone_logo.c4bc88fc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gramophone_logo.webp
// module id = 637
// module chunks = 0